module.exports = __webpack_public_path__ + "e18104da93d964992064485d3d081401.svg";